module.exports = __webpack_public_path__ + "img/EDC5000_aodo_1-1.7742d19f.jpg";